import {
  GuestsSelection,
  ICategorizedResponse,
  IResult,
  MegaMenuRegion,
  NonEmptyArray,
  StayTypesEnum,
  Place,
} from "redmond";

import * as actionTypes from "./constants";

export interface ISetLocationCategories {
  type: actionTypes.SET_LOCATION_CATEGORIES;
  categories: ICategorizedResponse[];
}

export const setLocationCategories = (
  categories: ICategorizedResponse[]
): ISetLocationCategories => ({
  type: actionTypes.SET_LOCATION_CATEGORIES,
  categories,
});

export interface IFetchMegaMenuRegions {
  type: actionTypes.FETCH_MEGAMENU_REGIONS;
}

export const fetchMegaMenuRegions = (): IFetchMegaMenuRegions => ({
  type: actionTypes.FETCH_MEGAMENU_REGIONS,
});

export interface ISetMegaMenuRegions {
  type: actionTypes.SET_MEGAMENU_REGIONS;
  regions: NonEmptyArray<MegaMenuRegion>;
}

export const setMegaMenuRegions = (
  regions: NonEmptyArray<MegaMenuRegion>
): ISetMegaMenuRegions => ({
  type: actionTypes.SET_MEGAMENU_REGIONS,
  regions,
});

export interface IFetchIsMegaMenuSelection {
  type: actionTypes.FETCH_IS_MEGAMENU_SELECTION;
}

export const fetchIsMegaMenuSelection = (): IFetchIsMegaMenuSelection => ({
  type: actionTypes.FETCH_IS_MEGAMENU_SELECTION,
});

export interface ISetIsMegaMenuSelection {
  type: actionTypes.SET_IS_MEGAMENU_SELECTION;
  isSelection: boolean;
}

export const setIsMegaMenuSelection = (
  isSelection: boolean
): ISetIsMegaMenuSelection => ({
  type: actionTypes.SET_IS_MEGAMENU_SELECTION,
  isSelection,
});

export interface ISetLocation {
  type: actionTypes.SET_LOCATION;
  location: IResult | null;
}

export const setLocation = (location: IResult | null): ISetLocation => ({
  type: actionTypes.SET_LOCATION,
  location,
});

export interface ISetFromDate {
  type: actionTypes.SET_FROM_DATE;
  date: Date | null;
}

export const setFromDate = (date: Date | null): ISetFromDate => ({
  type: actionTypes.SET_FROM_DATE,
  date,
});

export interface ISetUntilDate {
  type: actionTypes.SET_UNTIL_DATE;
  date: Date | null;
}

export const setUntilDate = (date: Date | null): ISetUntilDate => ({
  type: actionTypes.SET_UNTIL_DATE,
  date,
});

export interface ISetOccupancyCounts {
  type: actionTypes.SET_OCCUPANCY_COUNTS;
  counts: Omit<GuestsSelection, "rooms">;
}

export const setOccupancyCounts = (
  counts: Omit<GuestsSelection, "rooms">
): ISetOccupancyCounts => ({
  type: actionTypes.SET_OCCUPANCY_COUNTS,
  counts,
});

export interface ISetLocationAutocompleteError {
  type: actionTypes.SET_LOCATION_AUTOCOMPLETE_ERROR;
  error: boolean;
}

export const setLocationAutocompleteError = (
  error: boolean
): ISetLocationAutocompleteError => ({
  type: actionTypes.SET_LOCATION_AUTOCOMPLETE_ERROR,
  error,
});

export interface ISetLocationSearchString {
  type: actionTypes.SET_LOCATION_SEARCH_STRING;
  searchString: string;
}

export const setLocationSearchString = (
  searchString: string
): ISetLocationSearchString => ({
  type: actionTypes.SET_LOCATION_SEARCH_STRING,
  searchString,
});

export interface ISetStayType {
  type: actionTypes.SET_STAY_TYPE;
  stayType: StayTypesEnum;
}

export const setStayType = (stayType: StayTypesEnum): ISetStayType => ({
  type: actionTypes.SET_STAY_TYPE,
  stayType,
});

export interface ISetVacationRentalsLocationCategories {
  type: actionTypes.SET_VACATION_RENTALS_LOCATION_CATEGORIES;
  vacationRentalsCategories: ICategorizedResponse[];
}

export const setVacationRentalsLocationCategories = (
  vacationRentalsCategories: ICategorizedResponse[]
): ISetVacationRentalsLocationCategories => ({
  type: actionTypes.SET_VACATION_RENTALS_LOCATION_CATEGORIES,
  vacationRentalsCategories,
});

export interface ISetVacationRentalsLocation {
  type: actionTypes.SET_VACATION_RENTALS_LOCATION;
  vacationRentalsLocation: IResult | null;
}

export const setVacationRentalsLocation = (
  vacationRentalsLocation: IResult | null
): ISetVacationRentalsLocation => ({
  type: actionTypes.SET_VACATION_RENTALS_LOCATION,
  vacationRentalsLocation,
});

export interface ISetLodgingSelection {
  type: actionTypes.SET_LODGING_SELECTION;
  lodgingSelection: Place | undefined;
}

export interface IFetchIsFromHotelDatelessSearch {
  type: actionTypes.FETCH_IS_FROM_HOTEL_DATELESS_SEARCH;
}

export const fetchIsFromHotelDatelessSearch =
  (): IFetchIsFromHotelDatelessSearch => ({
    type: actionTypes.FETCH_IS_FROM_HOTEL_DATELESS_SEARCH,
  });

export interface ISetIsFromHotelDatelessSearch {
  type: actionTypes.SET_IS_FROM_HOTEL_DATELESS_SEARCH;
  isFromDatelessSearch: boolean;
}

export const setIsFromHotelDatelessSearch = (
  isFromDatelessSearch: boolean
): ISetIsFromHotelDatelessSearch => ({
  type: actionTypes.SET_IS_FROM_HOTEL_DATELESS_SEARCH,
  isFromDatelessSearch,
});

export const setLodgingSelection = (
  lodgingSelection: Place | undefined
): ISetLodgingSelection => ({
  type: actionTypes.SET_LODGING_SELECTION,
  lodgingSelection,
});

export interface IFetchPCLocationAutocomplete {
  type: actionTypes.FETCH_PC_LOCATION_AUTOCOMPLETE;
  queryString: string;
}

export const fetchPCLocationAutocomplete = (
  queryString: string
): IFetchPCLocationAutocomplete => ({
  type: actionTypes.FETCH_PC_LOCATION_AUTOCOMPLETE,
  queryString,
});

export interface IFetchVRLocationAutocomplete {
  type: actionTypes.FETCH_VR_LOCATION_AUTOCOMPLETE;
  queryString: string;
}

export const fetchVRLocationAutocomplete = (
  queryString: string
): IFetchVRLocationAutocomplete => ({
  type: actionTypes.FETCH_VR_LOCATION_AUTOCOMPLETE,
  queryString,
});

export type HotelSearchActions =
  | ISetLocationCategories
  | IFetchMegaMenuRegions
  | ISetMegaMenuRegions
  | IFetchIsMegaMenuSelection
  | ISetIsMegaMenuSelection
  | ISetLocation
  | ISetFromDate
  | ISetUntilDate
  | ISetOccupancyCounts
  | ISetLocationAutocompleteError
  | ISetLocationSearchString
  | ISetStayType
  | ISetVacationRentalsLocationCategories
  | ISetVacationRentalsLocation
  | IFetchIsFromHotelDatelessSearch
  | ISetIsFromHotelDatelessSearch
  | ISetLodgingSelection
  | IFetchPCLocationAutocomplete
  | IFetchVRLocationAutocomplete;
